import { render } from "./ElementsPage.vue?vue&type=template&id=761d51ff&scoped=true"
import script from "./ElementsPage.vue?vue&type=script&lang=js"
export * from "./ElementsPage.vue?vue&type=script&lang=js"

import "./ElementsPage.vue?vue&type=style&index=0&id=761d51ff&scoped=true&lang=css"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761d51ff"]])

export default __exports__